import { render, staticRenderFns } from "./AdminRicercaStanzeView.vue?vue&type=template&id=0d257aec&"
import script from "./AdminRicercaStanzeView.vue?vue&type=script&lang=ts&"
export * from "./AdminRicercaStanzeView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports